import { render, staticRenderFns } from "./EditAggregatedOffer.vue?vue&type=template&id=5370ffae&"
import script from "./EditAggregatedOffer.vue?vue&type=script&lang=js&"
export * from "./EditAggregatedOffer.vue?vue&type=script&lang=js&"
import style0 from "./EditAggregatedOffer.vue?vue&type=style&index=0&id=5370ffae&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports